import {getCurrentAction, getLevel} from "../selectors";
import {PlayerReduxDispatch, PlayerReduxState} from "../types";
import {analyticsSendEvent} from "../../../libs/analytics";
import {isMultipleChoiceUserInputAction, WithoutTypename} from "../../../types";
import {EducationSessionPassedResult, MutationEducationSessionMultipleSelectInputArgs} from "../../../schema";
import {sessionMultipleSelectMutation} from "../graphql";

export default function chooseMultipleOptions() {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    const state = getState();

    const action = getCurrentAction(state);

    if (!action && !isMultipleChoiceUserInputAction(action)) {
      console.warn("chooseMultipleOptions: wrong action");
      return;
    }

    const level = getLevel(state);
    const chosenBranches = Array.from(state.chosenBranches);
    const chosenBranchesData = Array.from(state.chosenBranchesData);

    analyticsSendEvent("playerChooseMultipleOptions", {
      sessionId: state.sessionId!,
      level: level,
      actionId: action.id,
      chosenBranches: chosenBranches.join(", "),
    });

    state.client
      .mutate<
        {
          result: WithoutTypename<EducationSessionPassedResult>;
        },
        MutationEducationSessionMultipleSelectInputArgs
      >({
        mutation: sessionMultipleSelectMutation,
        variables: {
          sessionId: state.sessionId!,
          level: level,
          actionId: action.id,
          chosenBranches: chosenBranches,
          chosenBranchesData: chosenBranchesData,
        },
      })
      .then((mutationResult) => {
        if (!mutationResult.data) {
          console.error("chooseMultipleOptions: invalid mutation result");
          dispatch({
            type: "update",
            payload: {isRecognizing: false},
          });
          return;
        }

        const result = mutationResult.data.result;

        const errorState = result.passed === false ? result.errorReason : null;
        dispatch({
          type: "update",
          payload: {
            isRecognizing: false,
            lastUserInputResult: {
              ok: !!result.passed,
              errorState: errorState ?? null,
            },
          },
        });

        if (result.interrupt) {
          dispatch({
            type: "interrupt",
            payload: {
              interruptReason: result.errorReason,
            },
          });
          return;
        }

        dispatch({type: "next"});
      })
      .catch((err) => {
        dispatch({
          type: "update",
          payload: {isRecognizing: false},
        });

        console.error(err);
      });
  };
}
